module.exports = __webpack_public_path__ + "static/media/laxmirajmv2.7e238e16.png";